import { useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import Swal from './swal';
import RoadiesShell from './RoadiesShell';
import { GameHead, TopBar, useSaveScore } from './common';
import { useGameTimer, useRotateNotice } from './hooks';

// s7.php: three unscramble questions; all must be answered, then reveal and score (1 each).
const QUESTIONS = [
  {
    text: '1. All across Mexico, members of the Church put on ______ to retell the Christmas story.',
    options: [
      { value: 'pinatas', label: 'P I Ñ A T A S' },
      { value: 'pastorelas', label: 'P A S T O R E L A S' },
      { value: 'posadas', label: 'P O S A D A S' },
    ],
    answer: 'pastorelas',
  },
  {
    text: '2. The Mexican Christmas season begins early in December with _______, a religious march that re-enacts the journey of Mary and Joseph.',
    options: [
      { value: 'lasposadas', label: 'L A S  P O S A D A S' },
      { value: 'losfuegos', label: 'L O S  F U E G O S' },
      { value: 'lafiestadelsol', label: 'L A  F I E S T A  D E L  S O L' },
    ],
    answer: 'lasposadas',
  },
  {
    text: '3. The vibrant red ______ flowers are also used in holiday arrangements for decoration throughout the country.',
    options: [
      { value: 'dahlia', label: 'D A H L I A' },
      { value: 'marigold', label: 'M A R I G O L D' },
      { value: 'poinsettia', label: 'P O I N S E T T I A' },
    ],
    answer: 'poinsettia',
  },
];

function Stage7Game() {
  const navigate = useNavigate();
  const { search } = useLocation();
  const game = useSelector((s) => s.roadies.game);
  const rotate = useRotateNotice();
  const timer = useGameTimer(true, game?.time);
  const save = useSaveScore();

  const base = game?.totalScore || 0;
  const [points, setPoints] = useState(base);
  const [picked, setPicked] = useState(['', '', '']);
  const [revealed, setRevealed] = useState(false);
  const busy = useRef(false);

  const cls = (qi, v) => {
    if (!revealed) return v === picked[qi] ? 'rd-option selected' : 'rd-option';
    if (v === QUESTIONS[qi].answer) return 'rd-option correct';
    if (v === picked[qi]) return 'rd-option wrong';
    return 'rd-option';
  };

  const choose = (qi, v) => {
    if (revealed) return;
    setPicked((prev) => {
      const next = [...prev];
      next[qi] = v;
      return next;
    });
  };

  const submit = async () => {
    if (busy.current) return;
    if (picked.some((p) => p === '')) {
      Swal.fire('', 'Please select an option for all questions.', 'info');
      return;
    }
    busy.current = true;
    setRevealed(true);
    const earned = QUESTIONS.reduce((sum, q, i) => sum + (picked[i] === q.answer ? 1 : 0), 0);
    const score = base + earned;
    setPoints(score);
    setTimeout(async () => {
      const state = await save(7, score, timer.current());
      if (state) navigate({ pathname: '/stage8', search });
      else busy.current = false;
    }, 2000);
  };

  return (
    <>
      {rotate && <div className="rd-rotate">Please rotate your device for the best experience</div>}
      <TopBar time={timer.text} points={points} />
      <GameHead title="Mexico" note="(Select the correct option for each)">
        Unscramble the keywords to identify how Mexicans celebrate the holidays.
      </GameHead>
      <div className="rd-game">
        <div className="rd-page-box">
          {QUESTIONS.map((q, qi) => (
            <div key={qi} className="rd-question">
              {q.text}
              <div className="rd-options">
                {q.options.map((o) => (
                  <div key={o.value} className={cls(qi, o.value)} onClick={() => choose(qi, o.value)}>
                    {o.label}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
        <div>
          <button type="button" className="rd-btn" onClick={submit} disabled={revealed}>Submit</button>
        </div>
      </div>
    </>
  );
}

export default function RoadiesStage7() {
  return (
    <RoadiesShell bg="phill.jpg" bgMob="phill-mob.jpg" stage={7} className="rd-stage rd-stage7">
      <Stage7Game />
    </RoadiesShell>
  );
}
